import { render, staticRenderFns } from "./HomeUpsellCard.vue?vue&type=template&id=6201e149"
import script from "./HomeUpsellCard.vue?vue&type=script&lang=js"
export * from "./HomeUpsellCard.vue?vue&type=script&lang=js"
import style0 from "./HomeUpsellCard.vue?vue&type=style&index=0&id=6201e149&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports